
import React from 'react';
import { Button } from "@/components/ui/button";
import { DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogBody } from "@/components/ui/dialog";
import ContactForm, { ContactFormData } from './ContactForm';

interface AddContactDialogProps {
  isMobile: boolean;
  formData: ContactFormData;
  setFormData: React.Dispatch<React.SetStateAction<ContactFormData>>;
  onAddContact: () => void;
}

const AddContactDialog: React.FC<AddContactDialogProps> = ({ 
  isMobile, 
  formData, 
  setFormData, 
  onAddContact 
}) => {
  return (
    <DialogContent className="sm:max-w-[550px]">
      <DialogHeader>
        <DialogTitle>Add New Contact</DialogTitle>
        <DialogDescription>
          Add a key contact for this lead. Enter their details below to keep track of important people.
        </DialogDescription>
      </DialogHeader>
      
      <DialogBody>
        <ContactForm formData={formData} setFormData={setFormData} />
      </DialogBody>
      
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline">Cancel</Button>
        </DialogClose>
        <Button onClick={onAddContact}>Add Contact</Button>
      </DialogFooter>
    </DialogContent>
  );
};

export default AddContactDialog;
